import script from "./minimanage.vue?vue&type=script&setup=true&lang=js"
export * from "./minimanage.vue?vue&type=script&setup=true&lang=js"

import "./minimanage.vue?vue&type=style&index=0&id=3132718e&lang=scss"

const __exports__ = script;

export default __exports__